import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  nombre: string;
  email: string;
  edad: number;
  grado: string;
  rol: string;
  avatar?: string;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  intusBaseUrl: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  
  setAuth: (user: User, accessToken: string, refreshToken: string, intusBaseUrl?: string) => void;
  setUser: (user: User) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      intusBaseUrl: null,
      isAuthenticated: false,
      isLoading: false,
      
      setAuth: (user, accessToken, refreshToken, intusBaseUrl) =>
        set({
          user,
          accessToken,
          refreshToken,
          intusBaseUrl: intusBaseUrl ?? null,
          isAuthenticated: true,
          isLoading: false,
        }),
      
      setUser: (user) => set({ user }),
      
      setTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken }),
      
      logout: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          intusBaseUrl: null,
          isAuthenticated: false,
          isLoading: false,
        }),
      
      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        intusBaseUrl: state.intusBaseUrl,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

